var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatbotDropIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7265 9.36302C18.2416 8.8817 19.0764 8.8817 19.6092 9.34698C19.8757 9.58764 20 9.89248 20 10.2134C20 10.5182 19.8757 10.823 19.6092 11.0476L13.4458 16.647C13.1972 16.8716 12.8597 17 12.5044 17C12.1492 17 11.8117 16.8716 11.5631 16.647L5.39964 11.0476C4.86679 10.5824 4.86679 9.8283 5.39964 9.34698C5.91474 8.8817 6.76732 8.8817 7.28242 9.36302L12.5044 14.096L17.7265 9.36302Z",
    fill: "#3573F9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatbotDropIcon);
export default __webpack_public_path__ + "static/media/chatbot-drop-icon.680208260a6cf6cd6d4610f72033425a.svg";
export { ForwardRef as ReactComponent };